/**
 * The "parent" id of the lookup will be listed first when available.
 * The parent groups are EUA, CITATION, and ORDER. PERMIT & VEHICLE can only
 * be accessed by an EUA or ORDER
 *
 * Unified Search Routes
 *  Citation -> citations/:id
 *  Order -> orders/:id
 *  Permit -> orders/:id
 *  Vehicle -> drivers/:id
 */
export const UNIFIED_SEARCH_FIELDS: { readonly [type: string]: ReadonlyArray<string> } = {
  CITATION: [
    '$citationNumber',
    '$citationIssueDate',
    '$citationType',
    '$citationStatus',
    '$vehicleLicensePlateNumber',
    '$vehicleLicensePlateState',
    '$vehicleMake',
    '$vehicleModel',
  ],
  EUA: [
    '$firstName',
    '$lastName',
    '$accountId',
    '$username',
    '$defaultEmail',
    '$ordersCount',
    '$activePermitsCount',
    '$citationsCount',
  ],
  ORDER: [
    '$orderId',
    '$orderNumber',
    '$orderDate',
    '$orderStatus',
    '$orderTotal',
    '$firstName',
    '$lastName',
    '$accountId',
    '$username',
    '$driverId',
  ],
  PERMIT: [
    '$orderId',
    '$id',
    '$permitNumber',
    '$permitType',
    '$issueDate',
    '$startDate',
    '$endDate',
    '$tempPermitIssueDate',
    '$licensePlateNumber',
    '$firstName',
    '$lastName',
    '$driverId',
    '$accountId',
  ],
  VEHICLE: [
    '$driverId',
    '$firstName',
    '$lastName',
    '$accountId',
    '$licensePlateNumber',
    '$licensePlateState',
    '$licensePlateType',
    '$make',
    '$model',
    '$color',
    '$type',
    '$ownerName',
  ],
  TEMP_PERMIT: [
    '$id',
    '$startDate',
    '$endDate',
    '$issueDate',
    '$licensePlateNumber',
    '$firstName',
    '$lastName',
    '$driverId',
    '$accountId',
  ],
};
